<template>
  <v-container fluid white class="py-3 white">
    <v-expansion-panel
        v-model="painelAberto"
        class="mt-3"
    >
      <template v-if="demandas && demandas.itens">
      <v-expansion-panel-content
          v-for="(demanda) in demandas.itens"
          :key="demanda.id"
      >
        <template v-slot:header>
          <v-layout align-center>
            <v-icon class="mr-3 grey--text">list</v-icon>

            <div>
              <span class=""><b class="primary--text">Contratação {{ demanda.numero }}</b></span>
              <span class="ml-2 mr-2">|</span>
              <span>Órgão: {{ demanda.siglaUnidadeOrganizacional }}</span>
              <span class="ml-2 mr-2">|</span>
              <span>Fornecedor: {{ demanda.razaoSocial }}</span>
              <span class="ml-2 mr-2">|</span>
              <span class="ml-2 mr-2">{{ demanda.situacao }}</span>
              <credenciamento-modal-motivo-cancelamento v-if="demanda.situacao === 'Cancelada'" :motivo="demanda.justificativaCancelamento"/>
            </div>
            <v-spacer></v-spacer>
            <div class="justify-end">
              <span v-if="demanda.situacao === 'Aguardando aprovação'" class="red--text font-weight-medium mr-2">Análise Pendente</span>
              <v-btn
                  v-if="demanda.situacao === 'Aguardando aprovação'"
                  class="ml-3 justify-end"
                  color="primary"
                  small
                  @click="analisarDemanda(demanda)"
              >
                Analisar
              </v-btn>
              <v-menu offset-y left v-if="demanda.situacao === 'Aprovada'">
                <v-btn slot="activator" icon>
                  <v-icon color="grey darken-3">more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="visualizarDemanda(demanda)">
                    <v-list-tile-content>
                      <v-list-tile-title>Visualizar</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider></v-divider>

                  <v-list-tile @click="baixarRelatorioDemanda(demanda)">
                    <v-list-tile-content>
                      <v-list-tile-title>Baixar</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </div>
          </v-layout>
        </template>
        <v-card>
          <v-card class="white demanda-painel">
            <div class="demanda-data-cadastro" data-testid="demanda-data-cadastro" v-if="demanda && demanda.dataCadastroFormatada">
              <span class="grey--text text--darken-1">Data Criação: {{ demanda.dataCadastroFormatada }}</span>
            </div>
            <v-data-table
                :headers="itemHeaders"
                :items="demanda.itens"
                :options="paginacoesItensPorDemanda[demanda.id]"
                :server-items-length="totalItensPorDemanda[demanda.id]"
                hide-actions
            >
              <template v-slot:items="props">
                <tr :key="props.item.id">
                  <td>{{ props.item.tipoItem }}</td>
                  <td>{{ props.item.sequencia }}</td>
                  <td>
                    <div style="display: flex; align-items: center; gap: 8px;">
                      <v-tooltip top class="tooltip-arredondado">
                        <template #activator="{ on, attrs }">
                          <chip-round
                            v-bind="attrs"
                            v-on="on"
                            :label="getTipoMaterialServico(props.item.tipo, 'sigla')"
                            :tamanho-fonte="'11px'"
                          />
                        </template>
                        <span style="white-space: nowrap;">
                          {{ getTipoMaterialServico(props.item.tipo, 'text') }}
                        </span>
                      </v-tooltip>
                      <span class="mr-1">{{ props.item.descricao }} - </span>
                    </div>
                  </td>
                  <td>{{ props.item.unidadeAquisicao }}</td>
                  <td class="text-xs-center">
                    <div class="d-flex align-center justify-center">
                      <span>{{ props.item.quantidade }}</span>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <paginacao-tabela
                :page="(paginacoesItensPorDemanda[demanda.id] && paginacoesItensPorDemanda[demanda.id].page) || 1"
                :itemsPerPage="(paginacoesItensPorDemanda[demanda.id] && paginacoesItensPorDemanda[demanda.id].rowsPerPage) || 10"
                :totalPaginas="totalPaginasPorDemanda[demanda.id] || 0"
                :totalItens="totalItensPorDemanda[demanda.id] || 0"
                @update-page="novaPagina => atualizarPaginaItens(demanda.id, novaPagina)"
            >
              <template #pagination-actions> <slot name="pagination-actions"></slot> </template>
            </paginacao-tabela>
          </v-card>
        </v-card>
      </v-expansion-panel-content>
      </template>
    </v-expansion-panel>
    <paginacao-tabela
        show-items-per-page
        :page="paginacaoInterna.page"
        :itemsPerPage="paginacaoInterna.rowsPerPage"
        :totalPaginas="totalPaginas"
        :totalItens="totalItens"
        @update-page="tratarEventoAtualizarPagina"
        @update-items-per-page="tratarEventoAtualizarItensPorPagina"
    >
      <template #pagination-actions> <slot name="pagination-actions"></slot> </template>
    </paginacao-tabela>
    <v-snackbar
        :value="snackbar.visible"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
        :top="snackbar.top"
        :right="snackbar.right"
        :multi-line="snackbar.multiLine"
    >
      {{ snackbar.message }}
      <v-btn text dark @click="snackbar.visible = false">
        <v-icon small>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import CredenciamentoModalNovaDemanda
  from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/Modal/CredenciamentoModalNovaDemanda.vue";
import actionTypes from "@/commons/constants/action-types";
import CredenciamentoCancelarDemanda
  from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/Modal/CredenciamentoCancelarDemanda.vue";
import CredenciamentoModalMotivoCancelamento
  from "@/views/credenciamento/detalhe-credenciamento/orgao/execucao/Modal/CredenciamentoModalMotivoCancelamento.vue";
import PaginacaoTabela from "@/commons/components/PaginacaoTabela.vue";
import ChipRound from "@/views/credenciamento/detalhe-credenciamento/commons/ChipRound.vue";

export default {
  components: {
    PaginacaoTabela,
    ChipRound,
    CredenciamentoModalMotivoCancelamento, CredenciamentoCancelarDemanda, CredenciamentoModalNovaDemanda},
  data: () => ({
    itemHeaders: [
      { text: 'Tipo', value: 'tipoItem', sortable: false, width: '7%' },
      { text: 'Seq.', value: 'sequencia', sortable: false, width: '5%' },
      { text: 'Código/Descrição', value: 'descricao', sortable: false, width: '58%' },
      { text: 'Un. Aquisição', value: 'unidadeAquisicao', sortable: false, width: '10%' },
      { text: 'Quantidade', value: 'quantidade', sortable: false, align: 'center', width: '20%' },
    ],
    snackbar: {
      visible: false,
      message: '',
      color: 'error',
      timeout: 4000,
      top: true,
      right: true,
      multiLine: false
    },
    demandas: null,
    painelAberto: null,
    credenciamentoId: null,
    editingDemandaId: null,
    editingItems: {},
    originalQuantities: {},
    totalItens: 0,
    totalPaginas: 0,
    paginacaoInterna: {
      groupBy: [],
      groupDesc: [],
      rowsPerPage: 10,
      multiSort: false,
      mustSort: false,
      page: 1,
      sortBy: 'id',
      sortByDefault: ['id'],
      descending: false,
      sortDescDefault: [true]
    },
    paginacoesItensPorDemanda: {},
    totalItensPorDemanda: {},
    totalPaginasPorDemanda: {},
  }),
  watch: {
    paginacaoInterna: {
      async handler(novoValor) {
        await this.buscarDemandas(novoValor)
      },
      deep: true,
    },
    painelAberto(novoIndice) {
      if (novoIndice != null && this.demandas && this.demandas.itens[novoIndice]) {
        const demanda = this.demandas.itens[novoIndice];
        this.abrirPainel(demanda);
      }
    }
  },
  async mounted(){
    this.credenciamentoId = this.$route.params.id;
    await this.buscarDemandas()
  },

  methods: {
    getTipoMaterialServico(sigla, chave) {
      const mod = require('@/commons/constants/tipo-item-material-servico').default || {};
      const lista = Object.values(mod);
      const norm = v => (v || '').toString().trim().toUpperCase();
      const t = norm(sigla);
      let item = lista.find(el => norm(el.sigla) === t || norm(el.value) === t || norm(el.text) === t);
      if (!item) {
        if (t.startsWith('M')) item = lista.find(el => norm(el.value) === 'MATERIAL');
        if (!item && (t.startsWith('S') || t.startsWith('SERV'))) item = lista.find(el => norm(el.value) === 'SERVICO');
      }
      return item ? item[chave] : null;
    },
    async buscarDemandas(){
      const dados = {
        credenciamentoId: this.credenciamentoId,
        fornecedorId: this.$store.state.loki.user.domainId,
        paginacao: this.paginacaoInterna,
      }

      const response = await this.$store.dispatch(actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_DEMANDAS_CREDENCIAMENTO, dados)

      if (response) {
        this.demandas = response
        this.totalItens = response.totalElements;
        this.totalPaginas = response.totalPages;
        this.incluirItens()
      }
      this.painelAberto = null;
    },
    incluirItens() {
      if (this.demandas && this.demandas.itens) {
        this.demandas.itens.forEach(demanda => {
          if (!demanda.hasOwnProperty('itens')) {
            this.$set(demanda, 'itens', []);
          }
        });
      }
    },
    analisarDemanda(demanda) {
      this.$router.push({
        name: 'AnaliseDemandaCredenciamentoFornecedor',
        params: {
          id: this.credenciamentoId,
          demandaId: demanda.id
        },
        query: {
          edicao: true,
          voltar: 'edicao'
        }
      });
    },
    visualizarDemanda(demanda) {
      this.$router.push({
        name: 'AnaliseDemandaCredenciamentoFornecedor',
        params: {
          id: this.credenciamentoId,
          demandaId: demanda.id
        },
        query: {
          edicao: false,
          voltar: 'edicao'
        }
      });
    },
    baixarRelatorioDemanda(demanda) {
      const documento = this.formatarDocumento(demanda);
      this.tratarEventoDownload(documento);
    },
    formatarDocumento(demanda) {
      const d = demanda;
      return {
        uri: d.uriRelatorioFornecimentoPedido,
        url: '/hal/public/arquivos?uri=' + d.uriRelatorioFornecimentoPedido + '&thumbnail=false',
      }
    },
    tratarEventoDownload(documento) {
      this.$store.dispatch(actionTypes.CREDENCIAMENTO.BAIXAR_DOCUMENTO, documento)
    },
    atualizarPaginacaoInterna(paginacao, sortByValue, sortDescValue) {
      this.paginacaoInterna.sortBy = paginacao[sortByValue]
      this.paginacaoInterna.sortDesc = paginacao[sortDescValue]
    },
    tratarEventoAtualizarPagina(page) {
      this.paginacaoInterna.page = page
    },
    tratarEventoAtualizarItensPorPagina(rowsPerPage) {
      this.paginacaoInterna.page = 1
      this.paginacaoInterna.rowsPerPage = rowsPerPage
    },
    atualizarPaginaItens(demandaId, novaPagina) {
      this.paginacoesItensPorDemanda[demandaId].page = novaPagina;
      const demanda = this.demandas.itens.find(d => d.id === demandaId);
      this.abrirPainel(demanda);
    },
    async abrirPainel(demanda) {
      const demandaId = demanda.id;

      if (!this.paginacoesItensPorDemanda[demandaId]) {
        this.$set(this.paginacoesItensPorDemanda, demandaId, {
          page: 1,
          rowsPerPage: 10,
          sortBy: 'id',
          descending: false,
        });
      }

      try {
        const paginacao = this.paginacoesItensPorDemanda[demandaId];

        const dados = {
          demandaId: demandaId,
          paginacao: paginacao
        };

        const resposta = await this.$store.dispatch(
            actionTypes.CREDENCIAMENTO.DEMANDA.BUSCAR_ITENS_POR_DEMANDA,
            dados
        );

        this.$set(demanda, 'itens', resposta && resposta.itens ? resposta.itens : []);
        this.$set(this.totalItensPorDemanda, demandaId, resposta && resposta.totalElements ? resposta.totalElements : 0);
        this.$set(this.totalPaginasPorDemanda, demandaId, resposta && resposta.totalPages ? resposta.totalPages : 0);
      } catch (e) {
        this.snackbar.message = 'Erro ao carregar itens da contratação';
        this.snackbar.color = 'error';
        this.snackbar.visible = true;
      }
    }
  }
}
</script>

<style scoped lang="stylus">
.demanda-painel {
  margin-bottom: 8px;
  border-radius: 4px;
  background-color: white !important;
  box-shadow: none !important;
  position: relative;
}

.demanda-data-cadastro {
  position: relative;
  height: 50px;
  display: flex;
  align-items: center;
  left: 12px;
  right: 12px;
}

.header-info span {
  font-size: 0.9em;
  color: rgba(0, 0, 0, 0.6);
}

.custom-table-header-text-color thead th {
  font-weight: 500;
  background-color: transparent !important;
}

.demand-items-table tbody tr {
  border-bottom: none !important;
}

.demand-items-table tbody td {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.v-btn--icon.v-btn--small .v-icon {
  font-size: 18px !important;
}

.edit-quantity-field {
  max-width: 80px !important;
  min-width: 60px !important;
}

.edit-quantity-field >>> .v-input__control {
  min-height: 32px !important;
}

.edit-quantity-field >>> .v-text-field__details {
  display: none !important;
}

.edit-quantity-field {
  background-color: #ffffff !important;
  border: 1px solid #0000a0 !important;
  border-radius: 6px;
  box-shadow: 0 0 4px #0067a5;
}

.edit-btn {
  opacity: 0.7;
  transition: opacity 0.2s;
}

.edit-btn:hover {
  opacity: 1;
}

.v-btn {
  transition: all 0.2s ease;
}

.confirmar {
  font-weight: 700;
}
</style>